var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.isLocked)?[_vm._v("\n    -\n  ")]:((_vm.$store.getters.getPackage != 'premium' || _vm.isCoachlab) && _vm.value)?[_c('v-premium-lock',{attrs:{"inline":true}})]:(_vm.$store.getters.getPackage == 'premium' && !_vm.isCoachlab && _vm.value)?[_vm._t("default")]:[_vm._v("-")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45ab9ff8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/analytics/CustomerItemValue.vue
// module id = null
// module chunks = 